import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { last } from 'lodash';

import {
  Tab, ListGroup,
  ListGroupItem, Button, Modal,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import {
  fetchAccountJobs, addAccountJob, updateAccountJob,
  deleteAccountJob,
} from '../../../Dashboard/DashboardActions';
import { getAccountJobs } from '../../../Dashboard/DashboardReducer';
import { getUser } from '../../../Auth/AuthReducer';
import ImportantTab from './ImportantTab';

import JobForm from './JobForm';
import Job from './Job';
import ProgressBar from '../../../../components/progress-bar';
import styles from '../opportunity-box/styles.css';

class JobTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addingMode: false,
      editingMode: false,
      showLogs: false,
    };
    this.hanldeSubmit = this.hanldeSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCancelShowForm = this.handleCancelShowForm.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.handleRequestDelete = this.handleRequestDelete.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.checkProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { isActive } = nextProps;
    if (isActive && this.props.isActive !== isActive) {
      this.checkProps(nextProps);
    }
    if (isActive && this.props.jobs.length > 0 && nextProps.jobs.length === 0) {
      this.setState({ showLogs: false });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  checkProps(props) {
    const {
      account, isLoading, isLoaded, isActive,
    } = props;
    const id = account.account_id;
    if (isActive && this.mounted && !isLoading && !isLoaded) {
      this.props.dispatch(fetchAccountJobs(id)).then(() => {
        if (this.mounted) {
          this.refreshTable();
        }
      });
    } else {
      this.refreshTable();
    }
  }

  closeModal() {
    this.setState({ showLogs: false });
  }

  hanldeSubmit(job, currentJob) {
    const params = { job: currentJob };
    const isNew = !job || !job._id;
    const action = isNew ? addAccountJob : updateAccountJob;
    const args = [this.props.account.account_id];
    if (!isNew) {
      args.push(job._id);
    }
    args.push(params);
    const p = this.props.dispatch(action(...args));
    p.then(
      () => {
        this.handleCancelShowForm();
      },
      () => {
        this.handleCancelShowForm();
      },
    );
    return p;
  }

  handleRequestDelete(job) {
    const p = this.props.dispatch(deleteAccountJob(this.props.account.account_id, job._id));
    p.then(
      () => {
        this.refreshTable();
      },
      () => {
        this.refreshTable();
      },
    );
    return p;
  }


  handleCancelShowForm() {
    this.setState({ addingMode: false }, () => {
      this.refreshTable();
    });
  }

  refreshTable() {
    if (this.props.measure) {
      this.props.measure();
    }
  }
  renderHistoryToggle() {
    const { isActive, jobs } = this.props;
    const { showLogs } = this.state;
    return (
      <div>
        {jobs.length > 1 &&
          <div className="text-right">
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                this.setState({ showLogs: true });
              }}
            >
              <small className="text-muted"><Fa name="clock-o" /> show job history</small>
            </a>
          </div>
        }
        {isActive &&
          <Modal show={showLogs} onHide={this.closeModal}>
            <Modal.Header closeButton>
              <Modal.Title>Job History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ maxHeight: 400, overflow: 'auto' }}>
                <ListGroup>
                  {jobs.map(job => (
                    <ListGroupItem key={job._id}>
                      {this.renderJob(job, true)}
                    </ListGroupItem>
                  ))}
                </ListGroup>
                <div style={{ height: 50 }}>&nbsp;</div>
              </div>
            </Modal.Body>
          </Modal>
        }
      </div>
    );
  }

  renderAddToggle() {
    return (
      <Button
        bsStyle="primary"
        bsSize="sm"
        onClick={() => {
          this.setState({ addingMode: true }, () => {
            this.refreshTable();
          });
        }}
      >
        <span><Fa name="plus" /> Add a new Job</span>
      </Button>
    );
  }

  renderJob(job, inModal = false) {
    if (!job) {
      return null;
    }
    const { auth } = this.props;
    return (
      <div className={(inModal ? null : 'well well-sm')}>
        <Job
          job={job}
          auth={auth}
          onEditModeChange={(editingMode) => {
            if (!inModal) {
              this.setState({ editingMode }, () => {
                this.refreshTable();
              });
            }
          }}
          requestEdit={this.hanldeSubmit}
          requestDelete={this.handleRequestDelete}
        />
      </div>
    );
  }

  renderJobs() {
    const { isLoaded, isLoading, jobs } = this.props;
    const loading = !isLoaded || isLoading;
    if (loading) {
      return <ProgressBar />;
    }

    const { addingMode, editingMode } = this.state;
    const lastJob = last(jobs);
    const hasJob = lastJob !== undefined;

    const showForm = addingMode || !hasJob;

    return (
      <div>
        <div><strong>Job to be done:</strong></div>
        {showForm &&
          <div className="well well-sm">
            <JobForm
              requestSubmit={this.hanldeSubmit}
              showCancel={hasJob}
              requestCancel={this.handleCancelShowForm}
            />
          </div>
        }
        {!showForm && hasJob && this.renderJob(lastJob)}
        {!showForm && !editingMode && <p />}
        {!showForm && !editingMode &&
          <div className="clearfix">
            <div className="pull-left">{this.renderAddToggle()}</div>
            <div className="pull-right">{this.renderHistoryToggle()}</div>
          </div>
        }
      </div>
    );
  }

  render() {
    const {
      eventKey, title, account, measure, isActive,
    } = this.props;
    return (
      <Tab eventKey={eventKey} title={title}>
        <div className={`${styles.section} text-left`}>{this.renderJobs()}</div>
        <ImportantTab account={account} measure={measure} isActive={isActive} />
      </Tab>
    );
  }
}

JobTab.propTypes = {
  account: PropTypes.shape({
    account_id: PropTypes.string,
  }).isRequired,
  auth: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({ job: PropTypes.string })).isRequired,
  dispatch: PropTypes.func.isRequired,
  measure: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
};

JobTab.defaultProps = {
  measure: () => {},
};

function mapStateToProps(state, ownProps) {
  const id = ownProps.account.account_id;
  const accountJobs = getAccountJobs(state, id) || {};
  const isLoading = accountJobs.status === 'loading';
  const isLoaded = accountJobs.status === 'loaded';
  const jobs = !isLoading && isLoaded ? accountJobs.jobs || [] : [];
  return {
    jobs,
    isLoading,
    isLoaded,
    auth: getUser(state),
  };
}

export default connect(mapStateToProps)(JobTab);
